import { render, staticRenderFns } from "./ExperienceDiscipline.vue?vue&type=template&id=177fe04d&"
import script from "./ExperienceDiscipline.vue?vue&type=script&lang=js&"
export * from "./ExperienceDiscipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports